import * as React from 'react'

function SvgNotiErrorLine(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12.105 2l.11.002c5.522.119 9.901 4.692 9.782 10.214C21.88 17.664 17.427 22 12.004 22l-.22-.002c-5.522-.12-9.9-4.692-9.782-10.214C2.12 6.336 6.573 2 11.995 2l.22.002zm-.109 2c-4.315 0-7.902 3.511-7.994 7.828-.096 4.41 3.415 8.075 7.825 8.17l.177.002c4.314 0 7.901-3.511 7.994-7.828.095-4.41-3.416-8.075-7.826-8.17zm.03 11.6A1.2 1.2 0 0112 18h-.026A1.2 1.2 0 0112 15.6zM12 6a1 1 0 011 1v6a1 1 0 01-2 0V6.999a1 1 0 011-1z" />
    </svg>
  )
}

export default SvgNotiErrorLine
